import zlVue from "@zhilian/zl-vue";
import tempGlobalData from "@/common/js/tempGlobalData";
import Cookies from 'js-cookie'

const util = zlVue.util;
util.remoteId = async ()=>{
    let res = await util.axios.get("obj/id");
    if (!res.module) {
        throw "服务调用失败,没有获取到新id";
    }
    return res.module;
}

// 以下两个get set方法，用于一次性传输数据， 默认10秒后清除数据
util.setData = (key,data,timeout=10000)=>{
    console.log('set key', key);
    tempGlobalData[key] = data;
    if (timeout && timeout > 0) {
        window.setTimeout(() => {
            console.log('清除临时数据key', key);
            delete tempGlobalData[key];
        },timeout);
    }
}
util.getData = (key)=>{
    console.log('get key', key);
    let d = tempGlobalData[key];
    delete tempGlobalData[key];
    return d;
}

/**
 * 生成编辑页面左上角抬头
 * @param name 页面名称
 * @param businessName  业务名称
 * @returns {string|*}
 */
const editTitle = function (name='', businessName='') {
    console.log('editTitle', {name, businessName});
    if (!!businessName) {
        return name + '  [ ' + businessName + " ] "
    } else {
        return name
    }
}
util.cookie = Cookies;
util.editTitle = editTitle;
export default util;
export const importUtil = {
    downLoadTemplateFile(businessType) {
        util.axios({
            url: 'fileImport/findFileImportTemplate',
            method: 'post',
            data: {'id': businessType},
        }).then(res => {
            if (res && res.module) {
                util.downloadBySaveAsWithSuffix(res.module.templateUrl, res.module.templateName)
            }
        })
    },
}
/**
 * 数组转树
 * @param array 带转换数组
 * @param reduceInfo 转换数结构的层级信息 {1:{unionFields:['1', '2'], dataFields:['1', '2', '3']}}
 * @param treeDep  转换出来的树深度
 * @param reduceType 归类数组的类型 1：后面数据reduceKey都为空则为同层级
 */
util.arrayToTree = function (array, reduceInfo = {}, treeDep = 2, reduceType = 1) {
    if (!array || array.length === 0) {
        return []
    }
    if (!reduceInfo) {
        return array
    }
    if (treeDep < 2) {
        return array
    }

    let getObj = (item, fields) => {
        let obj = {}
        for (let i = 0; i < fields.length; i++) {
            obj[fields[i]] = item[fields[i]]
        }
        return obj
    }

    // 要上线，先搞个两层
    let tree = [];
    let children = []
    for (let i = 0; i < array.length; i++) {
        let item = array[i];
        let isNewLine = true;
        let firstUnionFields = reduceInfo[1].unionFields;
        if (!!firstUnionFields && tree.length !== 0) {
            isNewLine = false;
            for (let j = 0; j < firstUnionFields.length; j++) {
                if (!isNewLine) {
                    isNewLine = item.hasOwnProperty(firstUnionFields[j])
                }
            }
        }
        if (isNewLine) {
            if (children.length > 0 && tree.length > 0) {
                tree[tree.length - 1]['children'] = children
                children = []
            }
            let firstDataFields = reduceInfo[1].dataFields;
            let obj = getObj(item, firstDataFields)
            tree.push(obj)
        }
        let secondDataFields = reduceInfo[2].dataFields;
        let secondObj = getObj(item, secondDataFields);
        children.push(secondObj);
        if (array.length - 1 === i && children.length > 0) {
            tree[tree.length - 1]['children'] = children
            children = []
        }
    }
    return tree;
}


util.handleErrItem = function (){
    this.$nextTick(() => {
        let errItem = document.querySelector(".el-form-item.is-error");
        console.log("验证表单，errItem = ", errItem);
        if (errItem) {
            let _errItem = errItem.querySelector(".el-form-item__error");
            if (_errItem) {
                errItem = _errItem;
            }
            this.$message.error(errItem.innerText.trim());
            errItem.scrollIntoView({
                behavior: "smooth"
            });
        }
    });
}




// WEBPACK FOOTER //
// ./src/common/js/util.js